import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';


export default function PieChart({ title = '', data = [], innerSize = 0 }) {
const options = {
chart: { type: 'pie', height: 320 },
title: { text: title },
plotOptions: {
pie: { innerSize: innerSize ? `${innerSize}%` : undefined, dataLabels: { enabled: innerSize ? false : true }, showInLegend: true },
},
series: [{ name: title || 'Items', data: (data || []).map((r) => ({ name: r.name || r.country, y: r.y ?? r.count ?? r.value })) }],
credits: { enabled: false },
};


return <HighchartsReact highcharts={Highcharts} options={options} />;
}